import { useDidUpdateEffect } from '@namespace/helpers';
import { useI18n } from '@namespace/i18n';
import { gamesStoreActions } from '../../store';
import { useGetPlatformForFeed } from '../useGetPlatformForFeed';

const { RESET_LANG_PLATFORM_RELATED_DATA } = gamesStoreActions;

export const useResetDataOnLangPlatformChange = () => {
  const platform = useGetPlatformForFeed();
  const { language } = useI18n();

  // TODO: for some reason "platform" is not updating on platform change via in devtool./
  // so reset works only on lang reset for now.
  useDidUpdateEffect(() => {
    RESET_LANG_PLATFORM_RELATED_DATA();
  }, [platform, language]);
};
